module.exports = __webpack_public_path__ + "assets/4c1e128f49aced3ee80b0d6af8e471c4.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/open.mp3
 ** module id = 368
 ** module chunks = 0
 **/